import * as Sentry from '@sentry/react';
import Loading from 'admin/components/shared/Loading';
import NotFound from 'admin/components/shared/NotFound';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUserInfo } from '../../actions/user';

// Workaround solution, TODO: Find a more robust solution within getUserInfo dispatches of User and PrivateMoney
let isLoadingUserInfo = false;

const Authorize = (PassedComponent, isAllowed) => {
  class AuthorizedComponent extends Component {
    componentDidMount() {
      if (_.isEmpty(this.props.user) && !isLoadingUserInfo) {
        isLoadingUserInfo = true;
        this.props.getUserInfo().finally(() => {
          isLoadingUserInfo = false;
        });
      }
    }

    render() {
      if (_.isEmpty(this.props.user)) {
        return <Loading />;
      } else if (isAllowed(this.props.user)) {
        const { id, name, email } = this.props.user;
        Sentry.setUser({ id, username: name, email });
        return <PassedComponent user={this.props.user}>{this.props.children}</PassedComponent>;
      }
      return <NotFound />;
    }
  }

  AuthorizedComponent.propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string,
      organization: PropTypes.object,
    }),
    children: PropTypes.element.isRequired,
    getUserInfo: PropTypes.func.isRequired,
  };

  AuthorizedComponent.defaultProps = {
    user: {},
  };

  const mapStateToProps = (state) => ({
    user: state.user,
  });

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        getUserInfo,
      },
      dispatch
    );

  return connect(mapStateToProps, mapDispatchToProps)(AuthorizedComponent);
};

export default Authorize;
